import { render, staticRenderFns } from "./RegularWithOriginTaskCell.vue?vue&type=template&id=4309a6b4&scoped=true"
import script from "./RegularWithOriginTaskCell.vue?vue&type=script&lang=js"
export * from "./RegularWithOriginTaskCell.vue?vue&type=script&lang=js"
import style0 from "./RegularWithOriginTaskCell.vue?vue&type=style&index=0&id=4309a6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4309a6b4",
  null
  
)

export default component.exports